import { isDeliverToFulfillmentCenter } from './is-deliver-to-fulfillment-center.util';
import { checkIsSwagOrResellerOrder } from './check-is-swag-or-reseller-order.util';
export function checkIsSwagOrResellerInventoryOrder(order, includeCustomInk = true) {
  return checkIsSwagOrResellerOrder(order, includeCustomInk) && !order.orderForCustomStore && isDeliverToFulfillmentCenter(order);
}